import { useMutation } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateCustomerPaymentMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createCustomerPaymentApi(data) {
    try {
      const api = `/customer/payment`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createCustomerPaymentApi", ...keyData],
    mutationFn: (data) => createCustomerPaymentApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("customerPayments");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createCustomerPayment: mutateAsync };
}

export function useUpdateCustomerPaymentMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateCustomerPaymentApi(data) {
    try {
      const api = `/customer/payment`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateCustomerPaymentApi", ...keyData],
    mutationFn: (data) => updateCustomerPaymentApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("customerPayments");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateCustomerPayment: mutateAsync };
}

export function useDeleteCustomerPaymentMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteCustomerPaymentApi(id) {
    try {
      const api = `/customer/payment/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteCustomerPaymentApi", ...keyData],
    mutationFn: (data) => deleteCustomerPaymentApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("customerPayments");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteCustomerPayment: mutateAsync };
}

// payment types
const paymentTypes = [
  {
    value: 1,
    label: "Cheque"
  },
  {
    value: 2,
    label: "Cash"
  },
  {
    value: 3,
    label: "Pay Order"
  },
  {
    value: 4,
    label: "Online"
  }
];

// get all payment type
export function getAllPaymentType() {
  return paymentTypes;
}

// get payment type by id
export function getPaymentTypeById(id) {
  return paymentTypes.find((item) => item.value === id) || null;
}
